export default __webpack_public_path__ + "0b8962397444c8d035482f8d250cf428.png";